import { useEffect, useState } from "react";
import { STORE_CLOSE_TIME, STORE_OPEN_TIME } from "./env";

export const useStoreTimer = () => {
    const getStoreOpen = () => {
        const now = new Date();

        const currentMinutes =
            now.getHours() * 60 + now.getMinutes();

        const [openHour, openMinute] = STORE_OPEN_TIME
            .split(":")
            .map(Number);

        const [closeHour, closeMinute] = STORE_CLOSE_TIME
            .split(":")
            .map(Number);

        const openMinutes = openHour * 60 + openMinute;
        const closeMinutes = closeHour * 60 + closeMinute;

        return (
            currentMinutes >= openMinutes &&
            currentMinutes < closeMinutes
        );
    };

    const [storeOpen, setStoreOpen] = useState<boolean>(() => getStoreOpen());

    useEffect(() => {
        const checkStoreStatus = () => {
            const isOpen = getStoreOpen();

            setStoreOpen(prev =>
                prev === isOpen ? prev : isOpen
            );
        };

        // Check immediately
        checkStoreStatus();

        // Check every second
        const interval = setInterval(checkStoreStatus, 1000);

        return () => clearInterval(interval);
    }, []);

    return {
        storeOpen,
    };
};